<template>
  <div class="head bg-white p-15 between-flex p-10">
    <span class="p-name p-relative fs-16 wg-900 ml-15 mt--10">{{
      pageTitle
    }}</span>
    <div class="icons d-flex align-center">
      <div class="properties-component">
        <PropertiesComponent />
      </div>
      <div class="properties-component" v-if="isNotification">
        <NotificationComponent />
      </div>
      <a :href="$router.resolve({ name: 'Profile' }).href" target="_blank">
        <img
          class="head-img"
          src="@/assets/img/avatar/avatar.png"
          alt="Profile"
        />
      </a>
    </div>
  </div>
</template>

<script>
import NotificationComponent from "./NotificationItemComponent.vue";
import PropertiesComponent from "./PropertiesComponent.vue";
import { mapGetters } from "vuex";

export default {
  name: "TopNavbar",
  components: {
    PropertiesComponent,
    NotificationComponent,
  },
  props: {
    isNotification: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters("pageTitle", ["pageTitle"]),
  },
};
</script>

<style scoped>
.icons span {
  font-size: 22px;
  border-radius: 50%;
  background-color: var(--hover-color);
  padding: 4px;
  cursor: pointer;
}

.icons span:hover {
  background-color: var(--un-hover-color);
}

.head .icons .notification::before {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  background-color: var(--red-color);
  border-radius: 50%;
  right: -1px;
  top: 0px;
}
</style>
